import { render, staticRenderFns } from "./Mentions.vue?vue&type=template&id=1a091265&scoped=true&"
import script from "./Mentions.vue?vue&type=script&lang=js&"
export * from "./Mentions.vue?vue&type=script&lang=js&"
import style0 from "./Mentions.vue?vue&type=style&index=0&id=1a091265&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a091265",
  null
  
)

export default component.exports